
// const createRollInnerForm = (): FormGroup => new FormGroup({
//     rollDay: new FormControl(null),
//     irregularPeriod: new FormControl([]),
//     rollConvention: new FormControl(null),
//     endOfFirstPeriod: new FormControl(null),
//     startOfLastPeriod: new FormControl(null),
// });

import { FormArray, FormControl, FormGroup } from "@angular/forms";
import { DateUtils } from "src/app/utils/date.utils";
import { KeyDatesEnum, ScheduleEnum, ScheduleType, SummaryEnum } from "../model/enums/product-capture.enums";
import { KeyDatesSchedulerPreFilter } from "../model/interfaces/key-dates-scheduler-pre-filter.interface";
import { KeyDatesScheduler } from "../model/interfaces/key-dates-scheduler.interface";

export const ScheduleFormUtils = {
    createDefaultScheduleForm: (key: ScheduleType) => new FormGroup<any>({
        scheduleType: new FormControl(''),
        type: new FormControl(''),
        frequency: new FormControl(''),
        pmtScheduleLag: new FormControl('0B'),
        pmtScheduleLagBase: new FormControl(),
        pmtRollConvention: new FormControl(),
        schedule: new FormArray([]),
        ...(key === ScheduleType.CALLABILITY && {
            [ScheduleEnum.callNoticeLag]: new FormControl(),
            [ScheduleEnum.callNoticeLagBaseType]: new FormControl(),
        }),
        ...(key === ScheduleType.COUPON && {
            [ScheduleEnum.accrualScheduleLagBase]: new FormControl(),
            [ScheduleEnum.accrualRollConvention]: new FormControl(),
            [ScheduleEnum.dayCount]: new FormControl(),
            [ScheduleEnum.refRateFixingLag]: new FormControl(),
        }),
        ...(key !== ScheduleType.PARTICIPATION && {
            obsRollConfig: ScheduleFormUtils.buildRollConfigForm(),
            accrualRollConfig: ScheduleFormUtils.buildRollConfigForm(),
            pmtRollConfig: ScheduleFormUtils.buildRollConfigForm(),
        }),
    }),
    buildRollConfigForm: () => new FormGroup({
        rollDay: new FormControl(),
        endFirstPeriod: new FormControl(),
        startLastPeriod: new FormControl(),
        irregularPeriod: new FormControl(),
    }),
    // Payload data helpers
    keyDatesForGetSchedulesPayload: (summaryForm: FormGroup): KeyDatesScheduler => {
        const keyDatesForm = summaryForm?.get(SummaryEnum.keyDates);
        const defaultField = 'value';

        const keyDate = (keyName: KeyDatesEnum, fieldName = defaultField) =>
        keyDatesForm?.get(keyName)?.get(fieldName)?.value;

        const stringFromDate = (keyName: KeyDatesEnum) =>
        keyDate(keyName)
            ? DateUtils.getStringFromDateObject(keyDate(keyName))
            : null;

        const keyDatesUnfiltered = {
            issueDate: stringFromDate(KeyDatesEnum.issueDate),
            maturityDate: stringFromDate(KeyDatesEnum.redemptionDate),
            initialFixingDate: stringFromDate(KeyDatesEnum.initialObservationDate),
            finalFixingDate: stringFromDate(KeyDatesEnum.finalObservationDate),
            interestStartDate: stringFromDate(KeyDatesEnum.interestStartDate),
            interestEndDate: stringFromDate(KeyDatesEnum.interestEndDate),
            dtePmtUnadjFirstT: stringFromDate(KeyDatesEnum.dtePmtUnadjFirstT),
            dtePmtUnadjLast0: stringFromDate(KeyDatesEnum.dtePmtUnadjLast0),
        };

        const keyDates = ScheduleFormUtils.removeNullEntries(keyDatesUnfiltered);

        return keyDates;
    },
    removeNullEntries: (obj: KeyDatesSchedulerPreFilter): KeyDatesScheduler => {
        return Object.keys(obj)
          .filter((key) => obj[key] != null)
          .reduce((accum, key) => ({ ...accum, [key]: obj[key] }), {});
    }
}

export class ScheduleTenor {
    
    unit: string;
    value: number;

    constructor(tenor: string) {
        this.unit = tenor.slice(-1);
        this.value = parseInt(tenor.slice(0, -1));
    }

    hasInvalidUnit(): boolean {
        const notComparableUnits = ['D', 'B'];
        return notComparableUnits.includes(this.unit);
    }

    isMultipleOf(tenor: ScheduleTenor): boolean {
        if (this.hasInvalidUnit() || tenor.hasInvalidUnit()) {
            return false;
        }

        if ((this.unit === 'W' && tenor.unit === 'M') || (this.unit === 'M' && tenor.unit === 'W')) {
            return false;
        }

        if (tenor.unit === 'Y') {
            if (this.unit === 'W')
                return (this.value % (tenor.value * 52)) === 0;
            if (this.unit === 'M')
                return (this.value % (tenor.value * 12)) === 0;
                
        }

        if (this.unit === 'Y') {
            if (tenor.unit === 'W') 
                return ((this.value * 52) % tenor.value) === 0;
            if (tenor.unit === 'M')
                return ((this.value * 12) % tenor.value) === 0;
        }

        return this.value > tenor.value && this.unit === tenor.unit && (this.value % tenor.value) === 0;
    }
}